module.exports = __webpack_public_path__ + "img/rpl-major.15f266de.png";